import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Imagem from 'Component/Imagem';
import Categoria from 'Interface/Categorias';
import { useEditarCategoriaMutation } from 'Service';

interface Props {
    dados: Categoria;
    acoes?: boolean;
}

export const CategoriaLista = ({dados, acoes = true}: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ editarCategoria ] = useEditarCategoriaMutation();

    const remover = async (): Promise<void> =>
    {
        try {
            await editarCategoria({ id: dados.id, ativo: false }).unwrap();

            toast({
                conteudo: 'Removido com sucesso!',
                tema: 'success',
            });
        } catch (erro) {
            toast({
                titulo: 'Erro ao remover',
                conteudo: 'Verifique o registro de log para mais detalhes!',
                tema: 'danger',
            });
        }
    }

    return (
        <div
            key={dados.nome}
            className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
        >
            <div className="d-flex align-items-center">
                <Link to={`/admin/categorias/editar/${dados.id}`}>
                    <Imagem src={dados.imagem} alt={dados.nome} className="rounded-circle object-fit-cover" width="80" height="80" />
                </Link>
                <div className="ms-4 fs-4">
                    <Link to={`/admin/categorias/editar/${dados.id}`} className="text-decoration-none">
                        {dados.nome}
                    </Link>
                    <small className="d-block fs-6 text-muted">Nome</small>
                </div>
            </div>
            <BrowserView className="d-flex align-items-center">
                <div className="ms-5 fs-5 text-end">
                    {dados.total_cursos}
                    <small className="d-block fs-6 text-muted">Total de cursos</small>
                </div>
                <div className="ms-5 fs-5 text-end">
                    {dados.criado.data().toLocaleString()}
                    <small className="d-block fs-6 text-muted">Criado em</small>
                </div>
                <div className="fs-5 flex-grow-1 text-end">
                    {acoes && (
                        <Botao
                            icone="trash"
                            tema="danger"
                            className="ms-5"
                            confirmacao="Você tem certeza que deseja remover essa categoria? Essa ação é irreversivel."
                            onClick={ remover }
                        />
                    )}
                </div>
            </BrowserView>
        </div>
    )
}
